
(async () => {
    const { Core } = await importModule('Core');
    const { $toggleDisplay } = await importModule('Utils');

    const ATTR_MONEY_TEMPLATE = "money-template";
    const ATTR_MAIN_VARIANT_PRICE = "main-variant-price";
    const ATTR_SHOW_TOTAL = 'show-total';

    customElements.define('product-buy-with', class extends Core {
        elements = {
            items: '*[data-element="complementary-item"]',
            subtotal :'[data-element="subtotal"]',
            subtotalPrice :'[data-element="subtotal-price"]',
        }

        subscriptions = {
            'cart:update':  '_uncheck'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this._handleChange();
        }

        _handleChange() {
            this.addEventListener('change', this._onChange.bind(this));
            this.addEventListener('click', e => {
                const btn = e.target.closest('[data-element="more"]');
                if (btn) this._toggleMore(btn);
            });
        }

        _onChange(e) {
            this._getCurrentItems();
            this.showTotal && this._updateSubtotal();
            this._publishChange();
            const input = e && e.target;
            if (input && input.matches && input.matches('[data-element="complementary-item"]')) {
                this._track('buy_with_toggle', {
                    buy_with_action: input.checked ? 'select' : 'deselect',
                    item_variant_id: input.value,
                    item_product_id: input.dataset.productId,
                    item_name: input.dataset.itemName,
                    item_position: +input.dataset.position,
                    item_price: +input.dataset.priceValue,
                    selected_count: this.checkedItems.length
                });
            }
        }

        // Liste repliée : « Voir les N autres produits » / « Voir moins »
        _toggleMore(btn) {
            const expanded = this.classList.toggle('!expanded');
            btn.setAttribute('aria-expanded', expanded);
            btn.querySelector('[data-more-label]').textContent = expanded ? btn.dataset.labelLess : btn.dataset.labelMore;
            this._track('buy_with_expand', {
                buy_with_action: expanded ? 'expand' : 'collapse',
                hidden_count: this.querySelectorAll('.\\#product-buy-with-item.\\@extra').length
            });
        }

        // dataLayer (GTM -> GA4) : paramètres communs à tous les événements « buy_with_* »
        _track(event, params) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({
                event,
                main_product_id: this.getAttribute('main-product-id'),
                main_product_title: this.getAttribute('main-product-title')
            }, params));
        }

        _getCurrentItems() {
            this.checkedItems = this.$items.filter(item => item.checked);
        }

        _uncheck() {
            // Le panier vient de changer : des produits cochés partent avec le produit principal
            if (this.checkedItems && this.checkedItems.length) {
                this._track('buy_with_add_to_cart', {
                    items_count: this.checkedItems.length,
                    item_variant_ids: this.checkedItems.map(i => i.value).join(','),
                    items_value: this.checkedItems.reduce((a, i) => a + (+i.dataset.priceValue), 0)
                });
            }
            this.checkedItems.map($checkbox => {
                $checkbox.checked = false;
            });
            $toggleDisplay(this.$subtotal, false);
            this._getCurrentItems();
            this._publishChange();
        }

        _publishChange() {
            this.publish('buyWith:change', { 
                selected: this.checkedItems.length
            })
        }

        _updateSubtotal() {
            this._getSubtotalWithCurrency();
            this.$subtotalPrice.innerText = this.subtotalWithCurrency;
            $toggleDisplay(this.$subtotal, !!this.checkedItems.length);
        }

        _getSubtotalWithCurrency() {
            this.subtotalWithCurrency = this.moneyTemplate.replace('{amount}', this.subtotalValue);

            if (typeof is_wcp_wholesale_customer != 'undefined') {
              if (is_wcp_wholesale_customer && typeof wpdExtensionIsProductPage != 'undefined') {
                try {
                  let productId = wpdExtensionIsProductPage.id;
                  let wcpJson = document.querySelector(`#wcp_json_${productId}`);
                  wcpJson = JSON.parse(wcpJson.textContent);
                  let wpdPrice = wcpJson.price;
                  if (wpdPrice) {
                    this.checkedItems.forEach((item) => {
                      let itemVariantId = item.value;
                      let wpdItemJson = document.querySelector(`.wcp_json_${itemVariantId}`);
                      wpdItemJson = JSON.parse(wpdItemJson.textContent);
                      let itemPrice = wpdItemJson.price;
                      wpdPrice += itemPrice;
                    })
                  this.subtotalWithCurrency = this.moneyTemplate.replace('{amount}', wpdPrice / 100);
                  }
                } catch (e) {}
              }
            }
        }
    
        get subtotalValue() {
            return this.checkedItems
                    .map(item => +item.dataset.priceValue)
                    .reduce((acc, price) => acc += price, +this.mainVariantPrice)
                    .toLocaleString(undefined, {minimumFractionDigits: 2})
        }

        get mainVariantPrice() {
            return this.getAttribute(ATTR_MAIN_VARIANT_PRICE);
        }

        get moneyTemplate() {
            return this.getAttribute(ATTR_MONEY_TEMPLATE);
        }

        get showTotal() {
            return this.hasAttribute(ATTR_SHOW_TOTAL);
        }
    })
})();